import PropTypes from 'prop-types';
import {Typography} from '../../../atoms/Typography';
import './AccountPreview.sass';

export const AccountPreview = ({user, onClick}) => {
  const hasUserImage =
    (user.image_url && user.image_url !== 'None') || (user.imgUrl && user.imgUrl !== 'None');
  const userImage = user.image_url || user.imgUrl;

  return (
    <button
      className="unstyled-button acct-details"
      onClick={onClick}
      data-qa-id="openAccountDetailsButton"
      type="button"
    >
      <div data-for="myEventsMovedTooltip">
        <div className="nav-avatar">
          {hasUserImage ? (
            <img src={userImage} alt="Profile" />
          ) : (
            <Typography as="p" variant="paragraph4" data-qa-id="userAvatarInitials" color="ghost">
              {user.initials}
            </Typography>
          )}
        </div>
      </div>
    </button>
  );
};

AccountPreview.propTypes = {
  user: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};
